export var Browser = /*#__PURE__*/ function(Browser) {
    Browser["Firefox"] = "firefox";
    Browser["Chrome"] = "chrome";
    Browser["Safari"] = "safari";
    Browser["Edge"] = "msedge";
    Browser["Opera"] = "opera";
    Browser["IE"] = "msie";
    Browser["SamsungBrowser"] = "samsungBrowser";
    Browser["Chromium"] = "chromium";
    return Browser;
}({});
export var BrowserType = /*#__PURE__*/ function(BrowserType) {
    BrowserType["Desktop"] = "desktop";
    BrowserType["Tablet"] = "tablet";
    BrowserType["Mobile"] = "mobile";
    return BrowserType;
}({});
export var OS = /*#__PURE__*/ function(OS) {
    OS["Linux"] = "linux";
    OS["MacOS"] = "mac";
    OS["Windows"] = "windows";
    OS["IOS"] = "ios";
    OS["Android"] = "android";
    OS["ChromeOS"] = "chromeos";
    return OS;
}({});

//# sourceMappingURL=getSystemInfo.types.js.map